import axios from 'axios';

import { cleanupData } from './data';

export function sendRequest(method, { endpoint, types, data, meta, params, cleanup = true }) {

    return (dispatch, getState) => {
        dispatch({
            type: types[0],
            data: cleanup ? cleanupData(data) : data,
            meta
        });

        return new Promise((resolve, reject) => {
            axios({
                method: method,
                url: endpoint,
                params: cleanup ? cleanupData(params) : params,
                data: cleanup ? cleanupData(data) : data,
                meta
            })
                .then(response => {
                    dispatch({
                        type: types[1],
                        data: response.data,
                        response,
                        meta
                    });

                    return resolve(response.data);
                })
                .catch(error => {
                    dispatch({
                        type: types[2],
                        error,
                        meta
                    });

                    reject(error && error.response && error.response.data || error);
                });
        });
    };
}

export function get({ endpoint, types, data, meta, params }) {
    return sendRequest('get', { endpoint, types, data, meta, params });
}

export function post({ endpoint, types, data, meta }) {
    return sendRequest('post', { endpoint, types, data, meta });
}

export function put({ endpoint, types, data, meta }) {
    return sendRequest('put', { endpoint, types, data, meta });
}

export function patch({ endpoint, types, data, meta }) {
    return sendRequest('patch', { endpoint, types, data, meta });
}

export function remove({ endpoint, types, data, meta }) {
    return sendRequest('delete', { endpoint, types, data, meta });
}



// WEBPACK FOOTER //
// ./assets/app/common/utils/api.js